const namespaced = true

const state = {
  products: [],
  product: {}
}

const getters = {
  products: state => state.products,
  product: state => state.product
}

const mutations = {
  SET_PRODUCTS: async (state, products) => {
      state.products = products
  },
  SET_PRODUCT: async (state, product) => {
      state.product = product
  }
}

const actions = {
  setProducts: ({ commit }, products) => {
    commit('SET_PRODUCTS', products)
  },
  setProduct: ({ commit }, product) => {
    commit('SET_PRODUCT', product)
  }
}

export const product = {
    namespaced,
    state,
    getters,
    actions,
    mutations
}
